import './FlexedList.scss';

import React, { FC } from 'react';

export const FlexedList: FC = ({ children }) => {
  return <div className={'flexedList'}>{children}</div>;
};
